import { render, staticRenderFns } from "./detail-tab.vue?vue&type=template&id=676d966d&scoped=true&"
import script from "./detail-tab.vue?vue&type=script&lang=js&"
export * from "./detail-tab.vue?vue&type=script&lang=js&"
import style0 from "./detail-tab.vue?vue&type=style&index=0&id=676d966d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676d966d",
  null
  
)

export default component.exports